/**
 * Confronto Handpan Selection — massimo 3 — localStorage
 */
(function () {
  'use strict';
  if (window.__vsHandpanCompare) return;
  window.__vsHandpanCompare = true;

  var KEY = 'vsHandpanCompare';
  var MAX = 3;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.slice(0, MAX) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  }

  function parseCard(trigger) {
    var card = trigger.closest('[data-vs-hp-compare-item]');
    if (!card) return null;
    var node = card.querySelector('[data-vs-hp-product]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function isSelected(id) {
    return read().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-vs-hp-compare]').forEach(function (btn) {
      var card = btn.closest('[data-vs-hp-compare-item]');
      var node = card && card.querySelector('[data-vs-hp-product]');
      var data = null;
      try {
        data = node ? JSON.parse(node.textContent) : null;
      } catch (e) {
        data = null;
      }
      var on = data ? isSelected(data.id) : false;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-active', on);
      if (card) card.classList.toggle('is-selected', on);
    });

    var list = read();
    document.querySelectorAll('[data-vs-hp-compare-count]').forEach(function (el) {
      el.textContent = String(list.length);
    });

    document.querySelectorAll('.vs-handpan-private').forEach(function (root) {
      root.classList.toggle('is-comparing', list.length > 0);
      var slots = root.querySelectorAll('.vs-hp-compare-slot');
      slots.forEach(function (slot, index) {
        var item = list[index];
        var img = slot.querySelector('img');
        slot.classList.toggle('is-filled', Boolean(item));
        if (!img) return;
        if (item && item.image) {
          img.src = item.image;
          img.alt = item.title || '';
          img.hidden = false;
        } else {
          img.removeAttribute('src');
          img.hidden = true;
        }
      });
    });
  }

  function row(label, value) {
    if (!value) return '';
    return (
      '<div class="vs-hp-specs__row"><span class="vs-hp-specs__label">' +
      label +
      '</span><span class="vs-hp-specs__value">' +
      value +
      '</span></div>'
    );
  }

  function renderPage() {
    var board = document.querySelector('[data-vs-hp-compare-board]');
    if (!board) return;
    var empty = document.querySelector('[data-vs-hp-compare-empty]');
    var list = read();
    if (empty) empty.hidden = list.length > 0;
    board.innerHTML = list
      .map(function (item) {
        return (
          '<article class="vs-hp-card vs-hp-compare-col">' +
          '<div class="vs-hp-card__media">' +
              (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title || '') + '">' : '') +
          '</div>' +
          '<div class="vs-hp-card__body">' +
          '<h2 class="vs-hp-card__title">' +
          escapeHtml(item.title || '') +
          '</h2>' +
          row('Scala', escapeHtml(item.scale)) +
          row('Note', escapeHtml(item.note_count)) +
          row('Hz', item.tuning_hz ? escapeHtml(item.tuning_hz) + ' Hz' : '') +
          row('Materiale', escapeHtml(item.material)) +
          row('Carattere', escapeHtml(item.character)) +
          row('Livello', escapeHtml(item.level)) +
          row('Prezzo', escapeHtml(item.price)) +
          row('Disponibilità', item.available ? 'Disponibile' : 'Non disponibile') +
          '<div class="vs-hp-card__footer">' +
          '<a class="vs-hp-btn vs-hp-btn--secondary" href="' +
          escapeHtml(item.url || '#') +
          '">Scopri</a>' +
          '<button type="button" class="vs-hp-btn vs-hp-btn--ghost" data-vs-hp-compare-remove="' +
          item.id +
          '">Rimuovi</button>' +
          '</div></div></article>'
        );
      })
      .join('');
  }

  function showLimit(root) {
    if (!root) return;
    root.setAttribute('data-vs-hp-compare-limit', 'true');
    window.setTimeout(function () {
      root.removeAttribute('data-vs-hp-compare-limit');
    }, 2200);
    window.alert('Hai già selezionato 3 handpan. Rimuovine uno per aggiungerne un altro.');
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-vs-hp-compare-remove]');
    if (remove) {
      var rid = remove.getAttribute('data-vs-hp-compare-remove');
      write(
        read().filter(function (item) {
          return String(item.id) !== String(rid);
        })
      );
      syncButtons();
      renderPage();
      return;
    }

    var trigger = event.target.closest('[data-vs-hp-compare]');
    if (!trigger) return;
    event.preventDefault();
    var data = parseCard(trigger);
    if (!data || !data.id) return;
    var list = read();
    var exists = list.some(function (item) {
      return String(item.id) === String(data.id);
    });
    if (exists) {
      list = list.filter(function (item) {
        return String(item.id) !== String(data.id);
      });
    } else if (list.length >= MAX) {
      showLimit(trigger.closest('.vs-handpan-private'));
      return;
    } else {
      list.push(data);
    }
    write(list);
    syncButtons();
    renderPage();
  });

  function boot() {
    syncButtons();
    renderPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
